require('./policiesWidget.style.scss');

class ProtectionGroupsController {
    constructor($scope, $filter, $rootScope, styleService, dashboardService, sharedPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this._dashboardService = dashboardService;
        this.ENDPOINT = sharedPersistenceService.getRestEndpoints().POLICIES_REST;
        this.donutColors = styleService.getDonutColor('policies');
        this.data = [
            {
                name: 'GREEN',
                value: 0,
                class: 'compliant icon-compliant',
                title: this.$filter('translate')('dashboard.panel.policies.status.compliant')
            },
            {
                name: 'RED',
                value: 0,
                class: 'uncompliant icon-uncompliant',
                title: this.$filter('translate')('dashboard.panel.policies.status.uncompliant')
            }
        ];
        this.renderCounter = 0;
    }

    $onInit() {
        this.updateData();
        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        this.data[0].value = this.widgetData.compliantCount;
        this.data[1].value = this.widgetData.unCompliantCount;
        this.renderCounter++;
    }

}

ProtectionGroupsController.$inject = ['$scope', '$filter', '$rootScope', 'styleService', 'dashboardService', 'sharedPersistenceService'];

const protectionGroupsComponent = {
    controller: ProtectionGroupsController,
    template: require('./policiesWidget.template.html'),
    scope: {},
    bindings: { widgetData: '<' },
};

module.exports = protectionGroupsComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/policiesWidget/policiesWidget.component.js